// src/pages/LandingPage.tsx
import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import NavBar from '../components/NavBar';

export default function LandingPage() {
  return (
    <>
      <NavBar />
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          px: 2,
          py: 8,
          textAlign: 'center'
        }}
      >
        {/* Headline */}
        <Typography variant="h3" fontWeight={600} gutterBottom>
          Book with SproutCo
        </Typography>

        {/* Subtext */}
        <Typography variant="body1" color="textSecondary" maxWidth="400px" mb={4}>
          Simple scheduling for small business pros. To book an appointment, please ask your service provider for their personal booking link.
        </Typography>
      </Box>
    </>
  );
}
